var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIotex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4390_1003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5225 0.5V5.96606L19.2612 3.23686L14.5225 0.5Z",
    fill: "url(#paint0_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M19.2612 3.23682V8.70288L24 5.96601L19.2612 3.23682Z",
    fill: "url(#paint1_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.5225 5.96606V11.4321L19.2612 8.70293L14.5225 5.96606Z",
    fill: "url(#paint2_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.2612 8.70288V14.1689L24 11.4321L19.2612 8.70288Z",
    fill: "url(#paint3_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.5225 11.4321V16.8982L19.2612 14.169L14.5225 11.4321Z",
    fill: "url(#paint4_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2612 14.1689V19.635L24 16.8981L19.2612 14.1689Z",
    fill: "url(#paint5_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.27368 5.78198V11.248L7.01244 8.51118L2.27368 5.78198Z",
    fill: "url(#paint6_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.25269 7.81372V13.2798L12.9838 10.5506L8.25269 7.81372Z",
    fill: "url(#paint7_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4.73877 11.2712V16.7373L9.47753 14.0004L4.73877 11.2712Z",
    fill: "url(#paint8_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M7.86218 15.3955V20.8616L12.5933 18.1247L7.86218 15.3955Z",
    fill: "url(#paint9_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M14.4843 17.7493V23.2153L19.2154 20.4785L14.4843 17.7493Z",
    fill: "url(#paint10_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M9.04114 5.11499V10.5811L13.7722 7.85185L9.04114 5.11499Z",
    fill: "url(#paint11_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.5224 0.5V5.96606L9.78369 3.23686L14.5224 0.5Z",
    fill: "url(#paint12_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.04112 2.823V8.28906L4.30237 5.5522L9.04112 2.823Z",
    fill: "url(#paint13_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.7799 5.52905V10.9951L9.04114 8.25825L13.7799 5.52905Z",
    fill: "url(#paint14_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M8.22972 7.81372V13.2798L3.49097 10.5506L8.22972 7.81372Z",
    fill: "url(#paint15_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.5225 11.4321V16.8982L9.79138 14.169L14.5225 11.4321Z",
    fill: "url(#paint16_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M4.73876 12.7048V18.1709L0 15.434L4.73876 12.7048Z",
    fill: "url(#paint17_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 5.96606V11.4321L19.2612 8.70293L24 5.96606Z",
    fill: "url(#paint18_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M19.2612 8.70288V14.1689L14.5225 11.4321L19.2612 8.70288Z",
    fill: "url(#paint19_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M24 11.4321V16.8982L19.2612 14.169L24 11.4321Z",
    fill: "url(#paint20_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.2612 14.1689V19.635L14.5225 16.8981L19.2612 14.1689Z",
    fill: "url(#paint21_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.4737 16.4458V21.9119L8.73499 19.1827L13.4737 16.4458Z",
    fill: "url(#paint22_linear_4390_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2612 3.23682V8.70288L14.5225 5.96601L19.2612 3.23682Z",
    fill: "url(#paint23_linear_4390_1003)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4390_1003",
    x1: -2069.26,
    y1: -565.741,
    x2: 8530.38,
    y2: 272.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4390_1003",
    x1: -2064.52,
    y1: -563.004,
    x2: 8535.13,
    y2: 275.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4390_1003",
    x1: -2069.26,
    y1: -560.275,
    x2: 8530.38,
    y2: 277.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4390_1003",
    x1: -2064.52,
    y1: -557.538,
    x2: 8535.13,
    y2: 280.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4390_1003",
    x1: -2069.26,
    y1: -554.809,
    x2: 8530.38,
    y2: 283.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4390_1003",
    x1: -2064.52,
    y1: -552.072,
    x2: 8535.13,
    y2: 286.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4390_1003",
    x1: -2081.51,
    y1: -560.459,
    x2: 8518.14,
    y2: 277.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4390_1003",
    x1: -2064.69,
    y1: -558.428,
    x2: 8484.03,
    y2: 277.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4390_1003",
    x1: -2079.05,
    y1: -554.97,
    x2: 8520.6,
    y2: 283.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4390_1003",
    x1: -2065.08,
    y1: -550.846,
    x2: 8483.64,
    y2: 284.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4390_1003",
    x1: -2058.45,
    y1: -548.492,
    x2: 8490.26,
    y2: 286.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4390_1003",
    x1: -2063.9,
    y1: -561.126,
    x2: 8484.81,
    y2: 274.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4390_1003",
    x1: -2074,
    y1: -565.741,
    x2: 8525.65,
    y2: 272.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4390_1003",
    x1: -2079.48,
    y1: -563.418,
    x2: 8520.16,
    y2: 274.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4390_1003",
    x1: -2074.74,
    y1: -560.712,
    x2: 8524.9,
    y2: 277.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4390_1003",
    x1: -2080.29,
    y1: -558.427,
    x2: 8519.35,
    y2: 279.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4390_1003",
    x1: -2063.15,
    y1: -554.809,
    x2: 8485.56,
    y2: 280.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4390_1003",
    x1: -2083.79,
    y1: -553.536,
    x2: 8515.86,
    y2: 284.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4390_1003",
    x1: -2064.52,
    y1: -560.275,
    x2: 8535.13,
    y2: 277.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4390_1003",
    x1: -2069.26,
    y1: -557.538,
    x2: 8530.38,
    y2: 280.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4390_1003",
    x1: -2064.52,
    y1: -554.809,
    x2: 8535.13,
    y2: 283.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4390_1003",
    x1: -2069.26,
    y1: -552.072,
    x2: 8530.38,
    y2: 286.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4390_1003",
    x1: -2075.05,
    y1: -549.795,
    x2: 8524.6,
    y2: 288.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4390_1003",
    x1: -2069.26,
    y1: -563.004,
    x2: 8530.38,
    y2: 275.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4390_1003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotex);
export default __webpack_public_path__ + "static/media/iotex.0d4e3d0094500fd252bec567608286dc.svg";
export { ForwardRef as ReactComponent };